import React from 'react';

/** Иконка мозга — маркер моделей с reasoning */
const BrainIcon = ({ size = 14, className = '', title = 'Reasoning' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden={!title}
        className={className}
        role={title ? 'img' : undefined}
    >
        {title ? <title>{title}</title> : null}
        <path
            d="M8.5 5.5a3.2 3.2 0 00-3.1 2.6A3.2 3.2 0 003.5 11c0 1.5.8 2.8 2 3.4v.4a3.8 3.8 0 003.5 3.7c.5.8 1.4 1.3 2.4 1.3h.2c.6 0 1.2-.2 1.7-.5.5.3 1.1.5 1.7.5h.2c1 0 1.9-.5 2.4-1.3a3.8 3.8 0 003.5-3.7v-.4c1.2-.6 2-1.9 2-3.4a3.2 3.2 0 00-1.9-2.9A3.2 3.2 0 0015.5 5.5c-1 0-1.9.4-2.5 1.1A3.1 3.1 0 008.5 5.5z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path
            d="M12 8.8v8.2M9.4 11c.7.3 1.5.5 2.6.5s1.9-.2 2.6-.5M9.2 14c.8.4 1.7.6 2.8.6s2-.2 2.8-.6"
            stroke="currentColor"
            strokeWidth="1.35"
            strokeLinecap="round"
        />
    </svg>
);

export default BrainIcon;
